interface QaElement {
  innerElTag?: string;
  customAttrs?: string[];
  nativeAttrs?: string[];
}

enum QaConstants {
  Button = 'button',
  Type = 'type',
  Input = 'input',
  Textarea = 'textarea',
  Select = 'select',
  Id = 'id',
  Class = 'class',
  Name = 'name',
  Label = 'label',
  AriaLabel = 'aria-label',
  AriaControls = 'aria-controls',
  BindLabel = 'bindlabel',
  FormControlName = 'formcontrolname',
  NgReflectName = 'ng-reflect-name',
  NgReflectLabel = 'ng-reflect-label',
  NgReflectType = 'ng-reflect-type',
  NgReflectText = 'ng-reflect-text',
  NgReflectHeader = 'ng-reflect-header',
  NgReflectField = 'ng-reflect-field',
  NgReflectTitle = 'ng-reflect-title',
  NgReflectBtnText = 'ng-reflect-btn-text',
  NgReflectLabelFrom = 'ng-reflect-label-from',
  NgReflectlabelTo = 'ng-reflect-label-to',
}

const rxButton: QaElement = {
  innerElTag: QaConstants.Button,
  customAttrs: [QaConstants.Type, QaConstants.NgReflectType],
  nativeAttrs: [QaConstants.Type],
};
const rxInput: QaElement = {
  innerElTag: QaConstants.Input,
  customAttrs: [
    QaConstants.FormControlName,
    QaConstants.NgReflectName,
    QaConstants.Type,
    QaConstants.Label,
  ],
  nativeAttrs: [QaConstants.Type],
};
const rxAutocomplete: QaElement = {
  innerElTag: QaConstants.Input,
  customAttrs: [
    QaConstants.FormControlName,
    QaConstants.NgReflectName,
    QaConstants.BindLabel,
  ],
  nativeAttrs: [QaConstants.Type],
};
const rxDatepickerRange: QaElement = {
  innerElTag: QaConstants.Input,
  customAttrs: [QaConstants.NgReflectLabelFrom, QaConstants.NgReflectlabelTo],
  nativeAttrs: [QaConstants.Id, QaConstants.Name],
};
const rxSelect: QaElement = {
  innerElTag: QaConstants.Select,
  customAttrs: [QaConstants.NgReflectName],
  nativeAttrs: [QaConstants.AriaLabel],
};
const rxRoomSelect: QaElement = {
  innerElTag: QaConstants.Button,
  customAttrs: [QaConstants.NgReflectName],
  nativeAttrs: [QaConstants.AriaLabel],
};
const rxCheckboxes: QaElement = {
  innerElTag: QaConstants.Input,
  nativeAttrs: [QaConstants.Id, QaConstants.Type],
};
const rxMapViewThumb: QaElement = {
  customAttrs: [QaConstants.NgReflectBtnText],
};
const rxRadio: QaElement = {
  nativeAttrs: [QaConstants.Id],
  innerElTag: QaConstants.Input,
  customAttrs: [QaConstants.Name, QaConstants.FormControlName],
};
const rxTextarea: QaElement = {
  nativeAttrs: [QaConstants.Id],
  innerElTag: QaConstants.Textarea,
  customAttrs: [QaConstants.FormControlName, QaConstants.NgReflectName],
};
const rxLabelValueCard: QaElement = {
  customAttrs: [QaConstants.NgReflectLabel],
};
const rxCardButton: QaElement = {
  customAttrs: [QaConstants.NgReflectText],
};
const rxDateCard: QaElement = {
  customAttrs: [QaConstants.NgReflectHeader],
};
const rxFormValidation: QaElement = {
  customAttrs: [QaConstants.NgReflectField],
};
const rxAlert: QaElement = {
  customAttrs: [QaConstants.NgReflectTitle, QaConstants.Type],
};
const aTag: QaElement = {};
const divTag: QaElement = {
  nativeAttrs: [QaConstants.AriaControls],
};
const buttonTag: QaElement = {
  nativeAttrs: [QaConstants.Class],
};

export const qaElements = {
  ['rx-button']: rxButton,
  ['rx-input']: rxInput,
  ['rx-autocomplete']: rxAutocomplete,
  ['rx-datepicker-range']: rxDatepickerRange,
  ['rx-select']: rxSelect,
  ['rx-room-select']: rxRoomSelect,
  ['rx-checkboxes']: rxCheckboxes,
  ['rx-map-view-thumb']: rxMapViewThumb,
  ['rx-radio']: rxRadio,
  ['rx-textarea']: rxTextarea,
  ['rx-label-value-card']: rxLabelValueCard,
  ['rx-card-button']: rxCardButton,
  ['rx-date-card']: rxDateCard,
  ['rx-validation-messages']: rxFormValidation,
  ['rx-alert']: rxAlert,
  ['a']: aTag,
  ['div']: divTag,
  ['button']: buttonTag,
};
